import { useDispatch, useSelector } from "react-redux";
import { selectMyProvider } from "../store/myProvider/selector";
import { createContext, useEffect, useState } from "react";
import { fetchLoginProviderList } from "../api/market";
import { errornotify } from "../Components/Message";
import { Helmet } from "react-helmet";
import { Container } from "reactstrap";
import LoginMarketSummary from "../Components/LoginMarketSummary";
import LoginTopPlan from "../Components/LoginTopPlan";
import USN_AllPlansMarketView from "../Components/USN_AllPlansMarketView";
import { useLocation } from "react-router-dom";
import { changeLocation, changeUtility } from "../store/actions";
import { selectUtilityList } from "../store/utility/selector";
import { selectLocation } from "../store/location/selector";

export const Context = createContext<any>({});

const PlanInsight = () => {
  const dispatch = useDispatch();
  const routerLocation = useLocation();
  const currentLocation = useSelector(selectLocation);
  const isTX = currentLocation?.state_id === "TX";
  const myProvider = useSelector(selectMyProvider);
  const [allProvider, setAllProvider] = useState([]);
  const utilityList = useSelector(selectUtilityList);

  const getAllProvider = async () => {
    const res = await fetchLoginProviderList();
    if (res.status !== 1) {
      setAllProvider([]);
      errornotify(res.message || "Error");
      // return;
    }
    setAllProvider(res.response);
  };

  useEffect(() => {
    getAllProvider();
  }, [currentLocation]);

  useEffect(() => {
    const searchParams = new URLSearchParams(routerLocation.search);
    const utility_id = searchParams.get("utility_id");
    if (!utility_id) return;
    if (!currentLocation || currentLocation.state_id !== "TX") {
      dispatch(changeLocation({ state_id: "TX", state_name: "Texas" }));
      return;
    }
  }, [routerLocation.search, currentLocation, dispatch]);

  useEffect(() => {
    const searchParams = new URLSearchParams(routerLocation.search);
    const utility_id = searchParams.get("utility_id");
    if (!utility_id || !utilityList) return;
    const allUtilities = [
      ...(utilityList.electricity || []),
      ...(utilityList.gas || []),
    ];
    const normalizedId = String(utility_id).trim();
    const newUtility =
      allUtilities.find(
        (u: any) => String(u?.utility_id ?? "").trim() === normalizedId
      ) || null;
    if (newUtility) {
      dispatch(changeUtility(newUtility));
    }
  }, [routerLocation.search, utilityList, dispatch]);

  return (
    <div className="page-content">
      <Helmet>
        <title>PowerRateIndex</title>
      </Helmet>
      <Context.Provider
        value={{
          provider: myProvider || {
            provider_id: "",
            provider_name: "",
            time: "",
          },
          allProvider,
          setAllProvider,
        }}
      >
        {isTX ? <TxComps /> : <UsnComps />}
      </Context.Provider>
    </div>
  );
};
const TxComps = () => {
  return (
    <Container>
      {/* <LoginMarketSummary /> */}
      <LoginTopPlan />
    </Container>
  );
};

const UsnComps = () => {
  return (
    <Container>
      <USN_AllPlansMarketView />
    </Container>
  );
};

export default PlanInsight;
